import React, { useMemo } from 'react';
import {
  Container,
  Typography,
  makeStyles,
  Tab,
  Tabs
} from '@material-ui/core';
import { Page } from 'src/components';
import { PriceListToolbar, SubHeader } from './components';
import { MainPriceListTable } from './components/MainPriceListTable';
import { usePriceList } from 'src/hooks/priceList';
import { colors } from 'src/constants';
import { useLocation } from 'react-router';
import { PoweredBuildStocksDialog } from './components/PoweredBuildStocksDialog';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    margin: theme.spacing(3),
    marginTop: theme.spacing(3)
  },
  modalContainer: {
    textAlign: 'right',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));

export const PriceListView = () => {
  const classes = useStyles();
  const { search } = useLocation();

  const {
    isLoading,
    priceListDate,
    initialQuery,
    productPriceList,
    params,
    poweredBuildsComponentData,

    onLoadMoreItems,
    onUpdatePriceList,
    setParams,
    handleTabChange,
    onHandlePoweredBuildsProductIds
  } = usePriceList();

  const isPoweredBuildsTable = useMemo(() => {
    return params?.tab === 1;
  }, [params]);

  const isIncomingPriceListTable = useMemo(() => {
    return params?.tab === 2;
  }, [params]);

  return (
    <Page className={classes.root} title="Price List">
      <Typography
        color="textPrimary"
        variant="h1"
        style={{ marginBottom: '1rem' }}
      >
        Price List
      </Typography>
      <Container maxWidth="xl">
        <PriceListToolbar
          isLoading={isLoading}
          isPoweredBuildsTable={isPoweredBuildsTable} // keep this here
          isIncomingPriceListTable={isIncomingPriceListTable}
          currentTab={params?.tab || 0}
          onResetParams={() => setParams(initialQuery)}
        />

        <Tabs
          variant="standard"
          value={params.tab ?? 0}
          onChange={(e, newVal) => handleTabChange(search, newVal)}
          style={{ margin: '1em 0' }}
        >
          <Tab
            label="All Products"
            style={{
              borderRadius: '.2em',
              background:
                !isPoweredBuildsTable && !isIncomingPriceListTable
                  ? colors.grey[100]
                  : ''
            }}
          />
          <Tab
            label="Powered Builds"
            style={{
              borderRadius: '.2em',
              background: isPoweredBuildsTable ? colors.grey[100] : ''
            }}
          />
          <Tab
            label="Incoming Products"
            style={{
              borderRadius: '.2em',
              background: isIncomingPriceListTable ? colors.grey[100] : ''
            }}
          />
        </Tabs>
        {/* TODO: add loaders here */}
        <div style={{ marginTop: '1rem' }}>
          <SubHeader
            priceListDate={priceListDate}
            isPoweredBuildsTable={isPoweredBuildsTable}
          />
        </div>
        <MainPriceListTable
          isLoading={isLoading}
          priceList={productPriceList}
          isPoweredBuildsTable={isPoweredBuildsTable}
          isIncomingPriceListTable={isIncomingPriceListTable}
          onUpdatePriceList={(data) => onUpdatePriceList(data)}
          onLoadMoreItems={onLoadMoreItems}
        />
        <PoweredBuildStocksDialog
          isOpen={poweredBuildsComponentData?.open}
          product_ids={poweredBuildsComponentData?.product_ids || []}
          handleClose={() =>
            onHandlePoweredBuildsProductIds({ product_ids: [], open: false })
          }
        />
      </Container>
    </Page>
  );
};
